var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Art(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2c7.732 0 14 6.22 14 13.892 0 7.672-6.268 13.891-14 13.891S2 23.563 2 15.892C2 8.219 8.268 2 16 2zm.282 5.799-.03.019-5.25 3.62-.02.014a1.388 1.388 0 0 0-.355 1.89l.023.033.014.021a1.405 1.405 0 0 0 1.9.353l.034-.022 3.052-2.105V22.67a1.397 1.397 0 0 0 1.4 1.368c.76 0 1.379-.603 1.4-1.354V8.93c-.025-1.092-1.252-1.73-2.168-1.131z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Art);
export default __webpack_public_path__ + "static/media/1ART.db165c5597e1c24d5cf4b610c956be0d.svg";
export { ForwardRef as ReactComponent };